<template>
  <OldDataTable :loading="loading" :rows="filteredItems" :cols-map="colsMap">
    <template #row="{sortedRows}">
      <TableRow v-for="item in sortedRows" :key="item.name">
        <td v-for="(col, _, index) in colsMap" :key="col">
          <span v-if="index === colsMapLength - 1" class="d-flex justify-content-between">
            {{ String(item[col]) && item[col] !== undefined ? String(item[col]) : '-' }}
            <ProductIconButtonGroup
              v-if="index === colsMapLength - 1"
              @delete="$emit('delete', item.id)"
              @update="$emit('update', item.id)"
            />
          </span>
          <template v-else>{{
            String(item[col]) && item[col] !== undefined ? String(item[col]) : '-'
          }}</template>
        </td>
      </TableRow>
    </template>
  </OldDataTable>
</template>
<script setup lang="ts">
interface Props {
  loading?: boolean;
  searchValue?: string;
  items: {[key: string]: any}[];
  colsMap: {[key: string]: string};
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
  searchValue: '',
  items: () => [],
});

defineEmits<{
  delete: [id: number];
  update: [id: number];
}>();

const colsMapLength = computed(() => (props.colsMap ? Object.keys(props.colsMap).length : 0));

const filteredItems = computed(() => {
  if (!props.searchValue) {
    return props.items;
  }
  return props.items.filter((item) => {
    return item.name.toLowerCase().includes(props.searchValue.toLowerCase());
  });
});
</script>
